export default __webpack_public_path__ + "static/media/Category=Inne.f22da5f1.png";